import React, { useState } from "react";
import { useRouter } from "next/router";
import { PACKAGE_COLORS } from "../../data/diagnosticQuestions";
import { API_ENDPOINT } from "../../utils/Constants";
import TrialWelcomeModal from "./TrialWelcomeModal";
import BookMeetingModal from "./BookMeetingModal";
import styles from "./ResultsCTA.module.scss";

const PACKAGE_NAMES = {
    kveikja: "Kveikja",
    vaxa: "Vaxa",
    efla: "Efla",
    dafna: "Dafna",
};

export default function ResultsCTA({ recommendation, contact, result }) {
    const { locale } = useRouter();
    const color = PACKAGE_COLORS[recommendation] || PACKAGE_COLORS.none;
    const pkgName = PACKAGE_NAMES[recommendation];
    const isNone = recommendation === "none";

    const [showTrialModal, setShowTrialModal] = useState(false);
    const [showBookModal, setShowBookModal] = useState(false);
    const [sendState, setSendState] = useState("idle");

    const primaryLabel = isNone
        ? locale === "en"
            ? "Explore education"
            : "Skoða fræðslu"
        : locale === "en"
          ? `Start with ${pkgName}`
          : `Byrja með ${pkgName}`;

    const bookLabel =
        locale === "en"
            ? "Book a short intro call"
            : "Bóka stuttan kynningarfund";

    const sendLabel =
        sendState === "sending"
            ? locale === "en"
                ? "Sending..."
                : "Sendi..."
            : sendState === "sent"
              ? locale === "en"
                  ? "✓ Sent to your email!"
                  : "✓ Sent á netfangið þitt!"
              : sendState === "error"
                ? locale === "en"
                    ? "Failed — try again"
                    : "Mistókst — reyndu aftur"
                : locale === "en"
                  ? "Send me the results"
                  : "Senda niðurstöður á mig";

    const handlePrimaryClick = () => {
        if (isNone) {
            window.open("/laufaskolinn", "_blank");
        } else {
            setShowTrialModal(true);
        }
    };

    const handleBookClick = () => {
        setShowBookModal(true);
    };

    const handleSendResults = async () => {
        if (sendState === "sending" || sendState === "sent" || !contact?.email)
            return;
        if (sendState === "error") setSendState("idle");
        setSendState("sending");

        try {
            const res = await fetch(
                `${API_ENDPOINT}public/send-diagnostic-results`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        name: contact.name,
                        email: contact.email,
                        company: contact.company,
                        recommendation: result.recommendation,
                        quiz_score: result.quizScore,
                        composite_scores: result.composite,
                        category_scores: result.categoryScores,
                        insights: result.insights,
                        package_text: result.packageText,
                    }),
                },
            );

            if (res.ok) {
                setSendState("sent");
            } else {
                setSendState("error");
            }
        } catch {
            setSendState("error");
        }
    };

    const handleTrialBookMeeting = () => {
        setShowTrialModal(false);
        setShowBookModal(true);
    };

    return (
        <>
            <div className={styles.ctaContainer}>
                <button
                    type="button"
                    className={styles.ctaPrimary}
                    style={{ backgroundColor: color }}
                    onClick={handlePrimaryClick}
                >
                    {primaryLabel}
                </button>
                <button
                    type="button"
                    className={styles.ctaSecondary}
                    onClick={handleBookClick}
                >
                    {bookLabel}
                </button>
                <button
                    type="button"
                    className={`${styles.ctaSecondary} ${sendState === "sent" ? styles.ctaSent : ""} ${sendState === "error" ? styles.ctaError : ""}`}
                    onClick={handleSendResults}
                    disabled={sendState === "sending" || sendState === "sent"}
                >
                    {sendLabel}
                </button>
            </div>

            {showTrialModal && (
                <TrialWelcomeModal
                    recommendation={recommendation}
                    contactName={contact?.name || ""}
                    contactEmail={contact?.email || ""}
                    onClose={() => setShowTrialModal(false)}
                    onBookMeeting={handleTrialBookMeeting}
                />
            )}

            {showBookModal && (
                <BookMeetingModal
                    contactName={contact?.name || ""}
                    contactEmail={contact?.email || ""}
                    contactCompany={contact?.company || ""}
                    recommendation={recommendation}
                    compositeScores={result?.composite || null}
                    quizScore={result?.quizScore || 0}
                    onClose={() => setShowBookModal(false)}
                />
            )}
        </>
    );
}
